module.exports = __webpack_public_path__ + "static/img/小家电banner21.539df045.png";